module.exports = __webpack_public_path__ + "_/img/MapMarker2_Red.5353d88c.svg";